import type { HeaderItemProps } from '@pixum/web-header';
import { PAGE_PATH } from 'components/constants';

type HandlerMap = {
  onService: () => void;
  onLanguage: () => void;
  onCart: () => void;
};

export function addHeaderOnClickHandlers(
  headerData: HeaderItemProps[],
  handlers: HandlerMap
): HeaderItemProps[] {
  return headerData.map(item => {
    if (item.href === PAGE_PATH.Service) {
      return { ...item, onClick: handlers.onService };
    }

    if (item.href === PAGE_PATH.CartOverview) {
      return { ...item, onClick: handlers.onCart };
    }

    if (item.subItems && item.subItems.length > 0) {
      return { ...item, onClick: handlers.onLanguage };
    }

    return item;
  });
}
